import { ApiRoutes } from '../../constant';
import request from '../../utils/request';

// eslint-disable-next-line import/prefer-default-export
export const getPlaceInformationService = (body) => request.post(`${ApiRoutes.PLACE_INFO}`, body);
